import * as React from 'react';

import { VerticalSliderFullscreen } from '../VerticalSlider';
import { AdvantageItem } from './components/AdvantageItem';

import { INewbuildingAdvantageSchema } from '../../repositories/newbuilding-card/entities/advantages/NewbuildingAdvantageSchema';
import { Section } from '../Section';

interface IAdvantagesProps {
  advantages: INewbuildingAdvantageSchema[];
  onItemClick(i: number): void;
}

export function Advantages({ advantages, onItemClick }: IAdvantagesProps) {
  return (
    <Section title="Особенности комплекса">
      <VerticalSliderFullscreen onItemClick={onItemClick}>
        {advantages.map(({ title, images }) => (
          <AdvantageItem key={title} title={title} imgUrl={images[0]?.url} />
        ))}
      </VerticalSliderFullscreen>
    </Section>
  );
}
